import { TOASTR_TYPE_ERROR, TOASTR_TYPE_SUCCESS } from '../../utils/toastr';

// Funkce pro zobrazení flash message
export const customToastr = (type, message) => {
    if (type !== TOASTR_TYPE_ERROR && type !== TOASTR_TYPE_SUCCESS) {
        throw new Error(`Toastr must be type of ${TOASTR_TYPE_ERROR} or ${TOASTR_TYPE_SUCCESS}, not ${type}!`);
    }

    const isErrorType = type === TOASTR_TYPE_ERROR;

    // Přidání dodatečných properties pro zamezení automatického schování
    const errorAdditionalConfig = {
        extendedTimeOut: 0,
        timeOut: 0,
    };

    const additionalConfig = isErrorType ? errorAdditionalConfig : {};

    toastr[type](message, '', additionalConfig);
};

export const initToastr = () => {
    // Nastavení flash messages přes plugin "toastr"
    toastr.options.progressBar = true;
};
